import React from 'react';

import "./MoneyCard.css";



interface MoneyDataProps {
   balanceNew: any;
}

const MoneyCard: React.FC<MoneyDataProps> = ({ balanceNew }: any): JSX.Element  => {



   return (

      <div className="card1">
         <img className='imgbank' src="/img/ukraine-hryvna.png" alt="" />
         <div className="textBoxBank">
            <p className="textbank headBank">Фонд Джунів #2</p>
            <span>Зібрано коштів:</span>
            <p className="textbank priceBank">{balanceNew} &#8372;</p>
         </div>
      </div>


   );
}

export default MoneyCard;
